import styled from "styled-components";
import { Section as CommonSection } from "../../../Common/Styles/containers";

export const Section = styled(CommonSection)`
  margin: 1.5rem 0;
`;
